/**
 * 新闻日例管理服务
 * created by lzy 2020.08.31
 */

'use strict';
angular.module('newsCalendarManagementServiceModule', ['calendarBulkImportModule', 'calendarImportPromptModule', 'resultPromptModule']).factory('newsCalendarManagementService', ['$q', '$modal', 'trsHttpService', '$sessionStorage',
    function($q, $modal, trsHttpService, $sessionStorage) {
        const curUserInfo = $sessionStorage.get('curUserInfo');
        return {
            /**
             * [bulkImport description] 批量导入
             *
             * @return  {[type]}   [return description]
             */
            bulkImport: function() {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './dateReminder/newsCalendarManagement/service/bulkImport/bulkImport.html',
                    windowClass: 'bulkImport',
                    backdrop: false,
                    controller: 'calendarBulkImportCtrl',
                });
                modalInstance.result.then(function (data) {
                    defer.resolve(data);
                });
                return defer.promise;
            },

            /**
             * [calendarImportPrompt description]导入提示
             *
             * @param  {[type]}  data   [data description]文件数据分析的结果
             *
             * @return  {[type]}   [return description]
             */
            calendarImportPrompt: function(data) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './dateReminder/newsCalendarManagement/service/calendarImportPrompt/calendarImportPrompt.html',
                    windowClass: 'modalHasTabel calendar-import-prompt',
                    backdrop: false,
                    controller: 'calendarImportPromptCtrl',
                    resolve: {
                        data: function() {
                            return data;
                        }
                    }
                });
                modalInstance.result.then(function (data) {
                    defer.resolve(data);
                });
                return defer.promise;
            },

            /**
             * [result description]导入结果提示
             *
             * @param  {[type]}  data   [data description]
             *
             * @return  {[type]}   [return description]
             */
            resultPrompt: function(data) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './dateReminder/newsCalendarManagement/service/prompt/resultPrompt.html',
                    windowClass: 'result-prompt',
                    backdrop: false,
                    controller: 'resultPromptCtrl',
                    resolve: {
                        data: function() {
                            return data;
                        }
                    }
                });
                modalInstance.result.then(function (data) {
                    defer.resolve(data);
                });
                return defer.promise;
            },

            /**
             * [getOrSaveExcelResult description] 保存excel解析结果
             *
             * @param  {[type]}  params   [params description]
             *
             * @return  {[type]}   [return description]
             */
            saveExcelResult: function(params) {
                var defer = $q.defer();
                params = angular.extend({
                    serviceId: 'daily',
                    method: 'doExcelataParseAndSave',
                    tenantid: curUserInfo.TENANTID,
                    userId: curUserInfo.ID
                }, params);
                trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'post').then(data => {
                    defer.resolve(data);
                }, error => {
                    defer.reject(error);
                })
                return defer.promise;
            },

            /**
             * [downloadErrorData description] 下载错误的新闻日历报告路径
             *
             * @param  {[type]}  params   [params description]
             *
             * @return  {[type]}   [return description]
             */
            downloadUrl: function(key) {
                const tenantid = curUserInfo.TENANTID;
                const userId = curUserInfo.ID;
                return `/message/daily/downloadErrorData?tenantid=${tenantid}&userId=${userId}&excelImportKey=${key}`
            }
        };
    }
]);